<template>
    <div class="images-block">
        <h4 v-if="!isOnlySingle">Изображения</h4>
        <div class="images-elems">
            <div class="load-image" v-if="!isOnlySingle">
                <label class="input-file">
                    <input type="file" @change="onFileChange" hidden />
                    <div class="input-file-content">
                        <svg width="25" height="25" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.67417 8.17433V0.21938H11.3258V8.17433L19.2808 8.17433L19.2808 10.826H11.3258L11.3258 18.7809H8.67417L8.67417 10.826H0.719224L0.719224 8.17433L8.67417 8.17433Z" fill="#6D6F71"/>
                        </svg>
                    </div>
                </label>
            <span class="max-size-text">Максимум {{ maxSize.name }}</span>
            </div>

            <!-- only one image -->
            <div class="load-image single-load-image" v-if="isOnlySingle">
                <label class="input-file" :style="`background: url(${imagesSrc[0] ? imagesSrc[0].src : ''})`">
                    <input type="file" @change="onFileChange" hidden />
                    <div class="input-file-content">
                        <svg width="25" height="25" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.67417 8.17433V0.21938H11.3258V8.17433L19.2808 8.17433L19.2808 10.826H11.3258L11.3258 18.7809H8.67417L8.67417 10.826H0.719224L0.719224 8.17433L8.67417 8.17433Z" fill="#6D6F71"/>
                        </svg>
                    </div>
                </label>
            </div>
            <div class="load-image" v-if="!isOnlySingle" v-for="elem in imagesSrc">
            <div class="loadedImage">
                <div class="img-elem" :style="`background: url(${elem.src})`">
                    <div class="delete-image">
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" @click="deleteImage($event, elem)">
                            <path d="M6.125 7.5L0.5 1.875L2.375 0L8 5.625L13.625 0L15.5 1.875L9.875 7.5L15.5 13.125L13.625 15L8 9.375L2.375 15L0.5 13.125L6.125 7.5Z" fill="white"/>
                        </svg>
                    </div>
                </div>
                <div class="cover"></div>
            </div>
                <span class="max-size-text">{{elem.size}}</span>
            </div>
        </div>
<!--    <button @click="submitForm">Отправить</button>-->
    </div>
</template>

<script>
import axios from 'axios';
import {CommonMixin} from "@/mixins/commonMethods";
export default {
    mixins: [CommonMixin],
    props: {
        images: {
            type: Array,
            required: false,
            default: []
        },
        defaultImages: {
            type: Array,
            required: false,
            default: []
        },
        isOnlySingle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            maxSize: {
                name: "20 МБ",
                size: 20971520
            },
            selectedFile: null,
            additionalParams: {
                productCode: 'B00000111213',
                typeName: 'Обычная'
            },
            imagesSrc: [],
            imgIndex: 1
        };
    },
    methods: {
        onFileChange(event) {
            const file = event.target.files[0];

            if (!file) return;

            if (file.size > this.maxSize.size) {
                return;
            }

            // Проверка формата файла
            if (!file.type.match('image.*')) {
                return;
            }

            // Чтение файла
            const reader = new FileReader();
            reader.onload = e => {
                if (this.isOnlySingle) {
                    this.imagesSrc = [{
                        src: e.target.result,
                        size: (file.size / 1024 / 1024).toFixed(2) + " МБ",
                        typeName: "Заглавная",
                        productCode: "",
                        index: this.imgIndex
                    }]
                    this.$emit('update:images', this.imagesSrc)
                    return
                }
                this.imagesSrc.push({
                    src: e.target.result,
                    size: (file.size / 1024 / 1024).toFixed(2) + " МБ",
                    typeName: this.imagesSrc.length === 0 ? "Заглавная" : "Обычная",
                    productCode: "",
                    index: this.imgIndex
                });

                this.$emit('update:images', this.imagesSrc)
                this.imgIndex++
            };
            reader.readAsDataURL(file);

            this.selectedFile = file;
        },
        deleteImage(event, img) {
            const index = this.imagesSrc.indexOf(img);
            if (index !== -1) {
                this.imagesSrc.splice(index, 1)
            }
            this.imgIndex--
            this.$emit('update:images', this.imagesSrc)
        },
        submitForm() {
            const formData = new FormData();
            formData.append('image', this.selectedFile);
            for (let key in this.additionalParams) {
                formData.append(key, this.additionalParams[key]);
            }

            axios.post(process.env.VUE_APP_API_URL + '/images/addImage', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {

            })
            .catch(error => {
                console.error('Error:', error);
            });
        },
    },
    watch: {
        defaultImages: function () {
            if (this.defaultImages?.length > 0) {
                // for (let i = this.defaultImages().length - 1; i >= 0; i--) {
                //     this.imagesSrc.push({
                //         src: this.setImageURL(this.images[i])
                //     })
                //     this.imgIndex++
                // }
                for (let image of this.defaultImages) {

                    this.imagesSrc.push({
                        src: this.setImageThumbURL(image),
                        size: "0 МБ",
                        typeName: image["Тип"],
                        productCode: this.$route.params.code,
                        index: this.imgIndex
                    })


                    this.$emit('update:images', this.imagesSrc)
                    this.imgIndex++
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@use '~@/assets/styles/vars' as *;


.load-image {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px
    }

    .images-block {
        width: 100%;
    }

    .input-file-content {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .input-file {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        text-align: center;
        background: $light-gray;
        width: 150px;
        height: 120px;

        position: relative;

        border-radius: 15px;
        padding: 20px;
        box-sizing: border-box;

        justify-content: center;
        align-items: center;

        gap: 10px;

        border: 1px solid $gray;
    }

    .max-size-text {
        //display: inline-block;
        font-size: 12px;
        color: $hard-gray;
        //position: absolute;
        //height: 100%;
    }

    .loadedImage {
        width: 150px;
        height: 120px;
        border-radius: 15px;

        border: 1px solid $gray;
        box-sizing: border-box;

        position: relative;
    }

    .loadedImage .img-elem {
        display: flex;
        justify-content: center;
        align-items: center;

        background-size: cover !important;
        width: 100%;
        height: 100%;
    }

    .loadedImage div {
        border-radius: 15px;
    }

    .loadedImage .delete-image {
        z-index: 2;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 25px;
        height: 25px;
        border: 2px solid rgba(255, 255, 255, 0.8);
        border-radius: 100px;
        cursor: pointer;
    }

    .loadedImage .delete-image svg {
        width: 13px;
        height: 13px;
    }

    .loadedImage .delete-image path {
        fill: rgba(255, 255, 255, 0.8)
    }

    .loadedImage div.cover {
        background: rgba(0, 0, 0, 0.7);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
    }

    .images-elems {
        display: flex;
        flex-direction: row;
        gap: 1%;
        row-gap: 10px;
        flex-wrap: wrap;
    }

    h4 {
        font-size: 22px;
        font-weight: 500;
        color: $black;
        margin-bottom: 15px;
    }

    label {
        background-size: 100% !important;
        background-position: center !important;
    }
</style>
